import React from 'react';

import { BORDER } from '../shared/style';

const HEIGHT = 60;

/* Aucun projet à planifier : ligne vide côté noms, message côté jours. */
export function emptyProjectRows(width) {
  return {
    rowsTotalH: HEIGHT,
    names: [
      <div
        key="empty"
        className="absolute top-[0] left-[0] right-[0] bg-white box-border"
        style={{ height: HEIGHT, borderBottom: BORDER }}
      />,
    ],
    bodies: [
      <div
        key="empty"
        className="absolute top-[0] left-[0] box-border py-[24px] px-[16px] text-[12.5px] text-grey-pale"
        style={{ width, height: HEIGHT, borderBottom: BORDER }}
      >
        Aucun projet avec briques — créez des phases et briques côté Clients pour les planifier ici.
      </div>,
    ],
  };
}
